// extracted by mini-css-extract-plugin
module.exports = {"helpContainer":"NeedMoreHelp_helpContainer__1i_uj"};